import { render } from "./howAreWeLearning.vue?vue&type=template&id=b86f5e1a&scoped=true"
import script from "./howAreWeLearning.vue?vue&type=script&lang=js"
export * from "./howAreWeLearning.vue?vue&type=script&lang=js"

import "./howAreWeLearning.vue?vue&type=style&index=0&id=b86f5e1a&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b86f5e1a"]])

export default __exports__